import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import {
  Home,
  List,
  FormatListNumbered,
  Report,
  SettingsAccessibility,
  Logout,
  Settings,
  Cancel,
  Map,
  Handshake,
  AddBusiness,
  HowToReg,
  ListAlt,
} from "@mui/icons-material";
import RootLayout from "../RootLayout";
import { useTheme } from "@mui/material/styles";


const invsetorAftercareHeadMenuItems = theme => [
  { key: "home", to: "/", title: "Home", iconClass: <Home /> },
  { key: "investorList", to: "/investorList", title: "Investor List", iconClass: <List /> },
    {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <AddBusiness />
      </Box>
    ),
    title: "Verification ",
    detail: [
    {
        key: "verifyInvestor",to: "/verifyInvestor", title: "Investor",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><HowToReg /></Box>),
       
   },
      
      {
        key: "verifyAggrement",to: "/verifyAggrement", title: "Agreement",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Handshake /></Box>),
         
	  },
      {
        key: "verfyRenewalRequest",to: "/verfyRenewalRequest", title: "Renewed Agreement",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Handshake /></Box>),
      },
      {
        key: "verifyTerminationRequest",to: "/verifyTerminationRequest", title: "Termination",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Cancel /></Box>),
      },
    ],
},
  { key: "viewMapByCategory", to: "/viewMapByCategory", title: "Map By Category", iconClass: <Map /> },
  {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <ListAlt />
      </Box>
    ),
    title: "List",
    detail: [
      {
        key: "agreementList",
        to: "/agreementList",
        title: "Agreements",
        iconClass: (
          <Box>
            <List />
          </Box>
        ),
      },
      {
        key: "investorList",
        to: "/investorList",
        title: "Investors",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <List />
          </Box>
        ),
      },
      {
        key: "propertyList",
        to: "/parcelList",
        title: "Parcels",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <FormatListNumbered />
          </Box>
        ),
      },
    ],
  },
  {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <ListAlt />
      </Box>
    ),
    title: "Report",
    detail: [
      
      {
        key: "investorList",
        to: "/investorReport",
        title: "Investors",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <List />
          </Box>
        ),
      },
      {
        key: "employment",
        to: "/employment",
        title: "Employement",
        iconClass: (
          <Box>
            <List />
          </Box>
        ),
      },
      {
        key: "tradereport",
        to: "/tradereport",
        title: "Trade",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <FormatListNumbered />
          </Box>
        ),
      },
      // {
      //   key: "InvAfterCareReport",
      //   to: "/InvAfterCareReport",
      //   title: "Report",
      //   iconClass: (
      //     <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
      //       <Report />
      //     </Box>
      //   ),
      // },
      {
        key: "arrear",
        to: "/arrear",
        title: "Arrear Report",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <Report />
          </Box>
        ),
      },
    ],
  },
  
  {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <AddBusiness />
      </Box>
    ),
    title: "Tariff(Rate) ",
    detail: [
      { key: "rentRateTable", to: "/rentRateTable", title: "Rent Rate Table", iconClass: <Settings /> },
      { key: "leaseRateTable", to: "/leaseRateTable", title: "Lease Rate Table", iconClass: <Settings /> },
    ],
},

  { key: "myPreference", to: "/myPreference", title: "Preferences", iconClass: <SettingsAccessibility /> },
  { key: "logout", to: "/logout", title: "Logout", iconClass: <Logout /> },
];

export default function OperationAndManagementHeadLayout() {
  const theme = useTheme();
  useEffect(() => {
    console.log(theme.palette);
  }, [theme.palette]);
  const [open, setOpen] = useState(true);
  const [showProfile, setShowProfile] = useState(true);

  return (
    <RootLayout
      department="Operations"
      open={open}
      setOpen={setOpen}
      showProfile={showProfile}
      setShowProfile={setShowProfile}
      menuList={invsetorAftercareHeadMenuItems(theme)}
    />
  );
}
